<!-- 日运输管理 -->
<template>
  <div class="nx-list-page">
    <matrix-statistics span="8" :list="infoCardData(pvCardData)"></matrix-statistics>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page"
      :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="(params, done) => { searchChange(params, done); getCardData() }" @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange"
      @on-load="(page) => { onLoad(page); getCardData() }" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot-scope="{row, }" slot="station">
        <p>发站:{{ row.beginStation }}</p>
        <p>到站:{{ row.endStation }}</p>
      </template>
      <template slot-scope="{row}" slot="planState">
        <matrix-tag v-if="row.planState == 0" color="#854D0E" text="未开始"></matrix-tag>
        <matrix-tag v-if="row.planState == 1" color="#166534" text="已进行"></matrix-tag>
        <matrix-tag v-if="row.planState == 2" color="#32b939" text="已完成"></matrix-tag>
      </template>
      <template #menu="{ size, row }">
        <el-button type="text" :size="size" @click="viewTask(row)">查看任务</el-button>
        <el-button type="text" :size="size" @click="send(row)">车皮到达(测试临时试用)</el-button>
      </template>
    </avue-crud>
    <showList ref="showList" :chooseOne="chooseOne"></showList>
    <select-contract ref="selectContract" @replace="replace" />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, getDaytransportplan, send, exportExcel } from "./api";
import { searchTimeConfig, rulesInput } from "@/basic-common/util/common";
import { downloadXls } from '@/util/util'
import matrixStatistics from '@/components/matrix/matrix-statistics'
import matrixTag from '@/components/matrix/matrix-tag'
import showList from './showList.vue'
import SelectContract from "@/views/railway-management/transportplan/components/select-contract.vue";

export default {
  components: { matrixStatistics, matrixTag, showList, SelectContract },
  mixins: [crudMixins],
  data() {
    return {
      chooseOne: {},
      apiConfig: { getList, add, update, remove, getDetail },
      exportLoading: false,
      /** 仅铁路入库日计划：与 api.getList 中 businessType/planType 固定条件一致 */
      defaultParams: {
        businessType: 1,
        planType: 2,
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,      // 隐藏新增按钮
        editBtn: false,     // 隐藏编辑按钮
        delBtn: false,      // 隐藏删除按钮
        column: [
          {
            label: '计划号',
            prop: 'planNo',
            overHidden: true, // 表格超出隐藏
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            minWidth: 180, // 表格最小宽度
            search: true, // 查询是否显示
            maxlength: 30,
          },
          {
            label: '计划名称',
            prop: 'planName',
            search: false, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 180,
            // type: 'select',
            // remote: true,
            allowCreate: true,
            // dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?planName={{key}}',
            props: {
              label: 'planName',
              value: 'planName'
            },
            maxlength: 30,
            rules: rulesInput(1),
          },
          {
            label: '合同名称',
            prop: 'contractName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            maxlength: 30,
            props: {
              label: 'contractName',
              value: 'id'
            },
            rules: rulesInput(2),
            click: () => {
              const { dialogForm } = this.$refs.crud.$refs
              if (dialogForm.boxVisible) {
                this.$refs.selectContract.open('1')
              }
            },
          },
          {
            label: '客户',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            width: 150,
            search: true, // 查询是否显示
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            rules: rulesInput(2),
          },

          {
            label: '物资名称',
            prop: 'cargoName',
            search: false, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            disabled: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?cargoName={{key}}',
            props: {
              label: 'cargoName',
              value: 'id'
            },
          },
          {
            label: '业务类型',
            prop: 'businessType',
            dataType: 'string',
            type: 'select',
            value: '1',
            dicData: this.$store.getters.commonDict['businessType'],
            hide: true,
            display: true,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '计划量(吨)',
            prop: 'planTotalWeight',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            overHidden: true, // 表格超出隐藏
            minWidth: 150,
            maxlength: 30,
            rules: rulesInput(1),
          },
          {
            label: '执行量(吨)',
            prop: 'planExecuteWeight',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: '车次',
            prop: 'trainNumber',
            overHidden: true, // 表格超出隐藏
            width: 150,
            rules: rulesInput(1),
            maxlength: 30,
          },
          {
            label: '发站',
            prop: 'beginStation',
            hide: true,
            type: 'select',
            filterable: true,
            dicUrl: '/api/produce/station/select/distinct/page',
            props: {
              label: 'stationName',
              value: 'stationCode'
            },
            rules: rulesInput(2),
          },
          {
            label: '到站',
            prop: 'endStation',
            hide: true,
            type: 'select',
            filterable: true,
            dicUrl: '/api/produce/station/select/distinct/page',
            props: {
              label: 'stationName',
              value: 'stationCode'
            },
            rules: rulesInput(2),
          },
          {
            label: '装货时间',
            prop: 'intervalStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 180,
          },
          {
            label: '状态',
            prop: 'planState',
            display: false,
          },
          {
            label: '计划开始时间',
            prop: 'intervalStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: false,
            showColumn: true,
            display: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
            width: 180
          },
          {
            label: '计划结束时间',
            prop: 'intervalEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: false,
            showColumn: true,
            display: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
            width: 180
          },
          {
            label: '合同开始时间',
            prop: 'contractStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true,
            disabled: true,
            showColumn: false,
          },
          {
            label: '合同结束时间',
            prop: 'contractEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            hide: true,
            disabled: true,
            showColumn: false,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
      pvCardData: {}
    }
  },
  computed: {
    infoCardData() {
      return function (pvCardData) {
        return [{
          label: '当月计划入库总量',
          value: pvCardData['planTotalWeight'],
          unit: ' 吨',
        }, {
          label: '当前计划执行量',
          value: pvCardData['planExecuteWeight'],
          unit: ' 吨',
        }, {
          label: '计划完成率',
          value: pvCardData['planProgress'],
          unit: ' %',
        }] // 卡片数据
      }
    }
  },
  methods: {
    viewTask(row) {
      this.chooseOne = row
      this.$refs['showList'].visible = true
    },
    replace(row) {
      const replaceKey = ['id', 'custNo', 'contractEndTime', 'contractStartTime', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        if (item != 'id') {
          this.$set(this.form, item, row[item])
        } else {
          this.$set(this.form, 'contractExtId', row['id'])
        }
      });
    },
    send({ planNo }) {
      send({ planNo }).then(() => {
        this.onLoad(this.page);
      })
    },
    getCardData() {
      getDaytransportplan({
        ...this.queryData
      }).then(({ data }) => {
        console.log(this.pvCardData, '222', data.data);
        this.pvCardData = data.data
      })
    },
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `铁路日运输计划_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}
</style>
